import { FC, ReactNode } from 'react';

interface Props {
  title: string;
  actions?: ReactNode;
  children: ReactNode;
}

export const WrapperBlock: FC<Props> = ({
  title,
  children,
  actions = null,
}) => {
  return (
    <div className='wrapper-block flex flex-col gap-3'>
      <div className='wrapper-block__header flex justify-between items-center'>
        <h4 className='wrapper-block__title font-heading text-heading-sm'>{title}</h4>
        {actions}
      </div>
      <div className='wrapper-block__content'>{children}</div>
    </div>
  );
};
